export default __webpack_public_path__ + "static/media/imgcita-min.ec378d7f.jpg";